// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-dropdown {
    position: relative;
    display: inline-block;
  }
  
  .notification-trigger {
    position: relative;
    padding: 8px 12px;
    cursor: pointer;
    border-radius: 8px;
    transition: background-color 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .notification-trigger:hover {
    background-color: #f8f9fa;
  }
  
  .notification-trigger i {
    font-size: 18px;
    color: #6c757d;
  }
  
  .notification-badge {
    position: absolute;
    top: 2px;
    right: 2px;
    background-color: #dc3545;
    color: white;
    border-radius: 50%;
    min-width: 18px;
    height: 18px;
    font-size: 11px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
  }
  
  .connection-status {
    position: absolute;
    bottom: 2px;
    right: 2px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    border: 1px solid white;
  }
  
  .connection-status.connected {
    background-color: #28a745;
  }
  
  .connection-status.connecting,
  .connection-status.reconnecting {
    background-color: #ffc107;
    animation: pulse 1s infinite;
  }
  
  .connection-status.disconnected,
  .connection-status.error {
    background-color: #dc3545;
  }
  
  @keyframes pulse {
    0% { opacity: 1; }
    50% { opacity: 0.5; }
    100% { opacity: 1; }
  }
  
  .notification-dropdown-menu {
    position: absolute;
    top: 100%;
    right: 0;
    width: 320px;
    max-height: 400px;
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 12px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    overflow: hidden;
    animation: slideDown 0.2s ease;
  }
  
  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  .notification-header {
    padding: 16px 20px;
    border-bottom: 1px solid #e9ecef;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f8f9fa;
  }
  
  .notification-header h6 {
    margin: 0;
    font-weight: 600;
    color: #495057;
    font-size: 16px;
  }
  
  .clear-all-btn {
    background: none;
    border: none;
    color: #6c757d;
    font-size: 12px;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 4px;
    transition: all 0.2s ease;
  }
  
  .clear-all-btn:hover {
    background-color: #e9ecef;
    color: #495057;
  }
  
  .notification-list {
    max-height: 280px;
    overflow-y: auto;
  }
  
  .notification-list::-webkit-scrollbar {
    width: 4px;
  }
  
  .notification-list::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  
  .notification-list::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 2px;
  }
  
  .notification-item {
    padding: 16px 20px;
    border-bottom: 1px solid #f8f9fa;
    cursor: pointer;
    transition: background-color 0.2s ease;
    position: relative;
    display: flex;
    align-items: flex-start;
    gap: 12px;
  }
  
  .notification-item:hover {
    background-color: #f8f9fa;
  }
  
  .notification-item.unread {
    background-color: #f0f8ff;
    border-left: 3px solid #007bff;
  }
  
  .notification-item:last-child {
    border-bottom: none;
  }
  
  .notification-content {
    flex: 1 1;
  }
  
  .notification-message {
    margin: 0 0 4px 0;
    font-size: 14px;
    color: #495057;
    line-height: 1.4;
  }
  
  .notification-time {
    font-size: 12px;
    color: #6c757d;
  }
  
  .unread-indicator {
    width: 8px;
    height: 8px;
    background-color: #007bff;
    border-radius: 50%;
    margin-top: 4px;
    flex-shrink: 0;
  }
  
  .no-notifications {
    padding: 40px 20px;
    text-align: center;
    color: #6c757d;
  }
  
  .no-notifications i {
    font-size: 32px;
    margin-bottom: 12px;
    opacity: 0.5;
  }
  
  .no-notifications p {
    margin: 0;
    font-size: 14px;
  }
  
  .notification-footer {
    padding: 12px 20px;
    border-top: 1px solid #e9ecef;
    background-color: #f8f9fa;
  }
  
  .view-all-btn {
    width: 100%;
    padding: 8px;
    background: #007bff;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s ease;
  }
  
  .view-all-btn:hover {
    background-color: #0056b3;
  }
  
  /* Responsive adjustments */
  @media (max-width: 768px) {
    .notification-dropdown-menu {
      width: 280px;
      right: -20px;
    }
  }
  
  /* Dark mode support */
  @media (prefers-color-scheme: dark) {
    .notification-dropdown-menu {
      background: #343a40;
      border-color: #495057;
    }
    
    .notification-header {
      background-color: #495057;
      border-bottom-color: #6c757d;
    }
    
    .notification-header h6 {
      color: #f8f9fa;
    }
    
    .notification-item {
      border-bottom-color: #495057;
    }
    
    .notification-item:hover {
      background-color: #495057;
    }
    
    .notification-message {
      color: #f8f9fa;
    }
    
    .notification-time {
      color: #adb5bd;
    }
    
    .no-notifications {
      color: #adb5bd;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/NotificationDropdown.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,sCAAsC;IACtC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,yBAAyB;IACzB,4BAA4B;EAC9B;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,KAAK,UAAU,EAAE;IACjB,MAAM,YAAY,EAAE;IACpB,OAAO,UAAU,EAAE;EACrB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,0CAA0C;IAC1C,aAAa;IACb,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;IACE;MACE,UAAU;MACV,4BAA4B;IAC9B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,sCAAsC;IACtC,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,2BAA2B;EAC3B;IACE;MACE,YAAY;MACZ,YAAY;IACd;EACF;;EAEA,sBAAsB;EACtB;IACE;MACE,mBAAmB;MACnB,qBAAqB;IACvB;;IAEA;MACE,yBAAyB;MACzB,4BAA4B;IAC9B;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,4BAA4B;IAC9B;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,cAAc;IAChB;EACF","sourcesContent":[".notification-dropdown {\n    position: relative;\n    display: inline-block;\n  }\n  \n  .notification-trigger {\n    position: relative;\n    padding: 8px 12px;\n    cursor: pointer;\n    border-radius: 8px;\n    transition: background-color 0.2s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .notification-trigger:hover {\n    background-color: #f8f9fa;\n  }\n  \n  .notification-trigger i {\n    font-size: 18px;\n    color: #6c757d;\n  }\n  \n  .notification-badge {\n    position: absolute;\n    top: 2px;\n    right: 2px;\n    background-color: #dc3545;\n    color: white;\n    border-radius: 50%;\n    min-width: 18px;\n    height: 18px;\n    font-size: 11px;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    line-height: 1;\n  }\n  \n  .connection-status {\n    position: absolute;\n    bottom: 2px;\n    right: 2px;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    border: 1px solid white;\n  }\n  \n  .connection-status.connected {\n    background-color: #28a745;\n  }\n  \n  .connection-status.connecting,\n  .connection-status.reconnecting {\n    background-color: #ffc107;\n    animation: pulse 1s infinite;\n  }\n  \n  .connection-status.disconnected,\n  .connection-status.error {\n    background-color: #dc3545;\n  }\n  \n  @keyframes pulse {\n    0% { opacity: 1; }\n    50% { opacity: 0.5; }\n    100% { opacity: 1; }\n  }\n  \n  .notification-dropdown-menu {\n    position: absolute;\n    top: 100%;\n    right: 0;\n    width: 320px;\n    max-height: 400px;\n    background: white;\n    border: 1px solid #e9ecef;\n    border-radius: 12px;\n    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);\n    z-index: 1000;\n    overflow: hidden;\n    animation: slideDown 0.2s ease;\n  }\n  \n  @keyframes slideDown {\n    from {\n      opacity: 0;\n      transform: translateY(-10px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  \n  .notification-header {\n    padding: 16px 20px;\n    border-bottom: 1px solid #e9ecef;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: #f8f9fa;\n  }\n  \n  .notification-header h6 {\n    margin: 0;\n    font-weight: 600;\n    color: #495057;\n    font-size: 16px;\n  }\n  \n  .clear-all-btn {\n    background: none;\n    border: none;\n    color: #6c757d;\n    font-size: 12px;\n    cursor: pointer;\n    padding: 4px 8px;\n    border-radius: 4px;\n    transition: all 0.2s ease;\n  }\n  \n  .clear-all-btn:hover {\n    background-color: #e9ecef;\n    color: #495057;\n  }\n  \n  .notification-list {\n    max-height: 280px;\n    overflow-y: auto;\n  }\n  \n  .notification-list::-webkit-scrollbar {\n    width: 4px;\n  }\n  \n  .notification-list::-webkit-scrollbar-track {\n    background: #f1f1f1;\n  }\n  \n  .notification-list::-webkit-scrollbar-thumb {\n    background: #c1c1c1;\n    border-radius: 2px;\n  }\n  \n  .notification-item {\n    padding: 16px 20px;\n    border-bottom: 1px solid #f8f9fa;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n    position: relative;\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n  }\n  \n  .notification-item:hover {\n    background-color: #f8f9fa;\n  }\n  \n  .notification-item.unread {\n    background-color: #f0f8ff;\n    border-left: 3px solid #007bff;\n  }\n  \n  .notification-item:last-child {\n    border-bottom: none;\n  }\n  \n  .notification-content {\n    flex: 1;\n  }\n  \n  .notification-message {\n    margin: 0 0 4px 0;\n    font-size: 14px;\n    color: #495057;\n    line-height: 1.4;\n  }\n  \n  .notification-time {\n    font-size: 12px;\n    color: #6c757d;\n  }\n  \n  .unread-indicator {\n    width: 8px;\n    height: 8px;\n    background-color: #007bff;\n    border-radius: 50%;\n    margin-top: 4px;\n    flex-shrink: 0;\n  }\n  \n  .no-notifications {\n    padding: 40px 20px;\n    text-align: center;\n    color: #6c757d;\n  }\n  \n  .no-notifications i {\n    font-size: 32px;\n    margin-bottom: 12px;\n    opacity: 0.5;\n  }\n  \n  .no-notifications p {\n    margin: 0;\n    font-size: 14px;\n  }\n  \n  .notification-footer {\n    padding: 12px 20px;\n    border-top: 1px solid #e9ecef;\n    background-color: #f8f9fa;\n  }\n  \n  .view-all-btn {\n    width: 100%;\n    padding: 8px;\n    background: #007bff;\n    color: white;\n    border: none;\n    border-radius: 6px;\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n  }\n  \n  .view-all-btn:hover {\n    background-color: #0056b3;\n  }\n  \n  /* Responsive adjustments */\n  @media (max-width: 768px) {\n    .notification-dropdown-menu {\n      width: 280px;\n      right: -20px;\n    }\n  }\n  \n  /* Dark mode support */\n  @media (prefers-color-scheme: dark) {\n    .notification-dropdown-menu {\n      background: #343a40;\n      border-color: #495057;\n    }\n    \n    .notification-header {\n      background-color: #495057;\n      border-bottom-color: #6c757d;\n    }\n    \n    .notification-header h6 {\n      color: #f8f9fa;\n    }\n    \n    .notification-item {\n      border-bottom-color: #495057;\n    }\n    \n    .notification-item:hover {\n      background-color: #495057;\n    }\n    \n    .notification-message {\n      color: #f8f9fa;\n    }\n    \n    .notification-time {\n      color: #adb5bd;\n    }\n    \n    .no-notifications {\n      color: #adb5bd;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
